import { render, staticRenderFns } from "./ordersOverviewSummaryTable.vue?vue&type=template&id=68cb523f&"
import script from "./ordersOverviewSummaryTable.vue?vue&type=script&lang=ts&"
export * from "./ordersOverviewSummaryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports